module.exports = __webpack_public_path__ + "91e220b0d9f17b32c45edc39a9b0081c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banners/akorda_ru.jpg
// module id = 267
// module chunks = 0